module.exports = __webpack_public_path__ + "img/11.8f553d5d.jpg";